import { render } from "./MigrateItemForm.vue?vue&type=template&id=163f8422"
import script from "./MigrateItemForm.vue?vue&type=script&lang=js"
export * from "./MigrateItemForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/cargo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__